import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountSettingsDetailsConfig } from '@shared/products-feature-configs';

export const settingsDetails: DeepPartial<CurrentAccountSettingsDetailsConfig> = {
    displayAccountOwner: true,
    displayBalance: true,
    displayCancelledState: true,
    displayCreationDate: true,
    displayClosingDate: true,
    displayDebitInterestAccrued: true,
    displayDisposable: true,
    displayFeesAccrued: true,
    displayOverdraft: true,
    displayOverdraftClientLimit: true,
    displayOverdraftDueDate: true,
    displaySecondaryIdManagement: true,
    displayBIC: true,
    displayDashedBBAN: true,
    displayIBAN: true,
    showDetailedOverdraftBox: true,
};
